import { IconProps } from "../../types/genereal";
import { IconWrapper } from "components/ui/IconWrapper";

export const ClockInCircleIcon = ({
  width = "24",
  height = "24",
  color = "#FE8836",
}: IconProps) => {
  return (
    <IconWrapper width={width} height={height}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.0645 4.00026C13.4467 4.01149 14.8029 4.38036 16 5.07155C17.2162 5.7737 18.2256 6.78411 18.9277 8.00026C19.6298 9.21638 20 10.596 20 12.0003C19.9999 13.4043 19.6298 14.7833 18.9277 15.9993C18.2256 17.2154 17.2162 18.2259 16 18.928C14.7839 19.6301 13.4043 19.9993 12 19.9993C10.5958 19.9993 9.2161 19.6301 8 18.928C6.78385 18.2258 5.77341 17.2155 5.07129 15.9993C4.36931 14.7832 3.99996 13.4034 4 11.9993L4.00391 11.7405C4.04871 10.3589 4.45083 9.01226 5.1709 7.83229C5.89094 6.65239 6.90419 5.67874 8.1123 5.0071C9.32039 4.3355 10.6823 3.98909 12.0645 4.00026ZM11.2998 8.30007V12.5003C11.2999 12.734 11.417 12.9525 11.6113 13.0823L15.1943 15.471L15.9707 14.3059L15.3887 13.9182L12.7002 12.1253V8.30007H11.2998Z"
          fill={color}
        />
      </svg>
    </IconWrapper>
  );
};
